(function ($, Cobalt, undefined) {
    // todo: make this return 
    Cobalt.Modal = {
    	initialize: function () { },
    	openModal: function (href, title, modalWidth, modalHeight, modalClass, disableScrolling, sizeToWindow, minWidth, maxWidth, maxHeight, autoHeight) {
    	    // create the dialog
    	    var $dialogDiv = $("<div>");
    	    var isOpen = false;
    	    $dialogDiv.dialog(
            {
                draggable: false,
                title: title,
                autoOpen: false,
                width: (modalWidth > 0) ? modalWidth : "auto",
                height: (modalHeight > 0) ? modalHeight : "auto",
                modal: true,
                resizable: false,
                closeText: '×',
                dialogClass: modalClass,
                close: function (event, ui) {
                    Cobalt.TinyMCE.removeEditor($dialogDiv);
                    $dialogDiv.dialog("destroy");
                    $dialogDiv.remove();
                    isOpen = false;
                    if (disableScrolling) {
                        $("body").css({ overflow: 'inherit' });
                    }
                },
                open: function () {
                    isOpen = true;

                    var modal = $dialogDiv.parent();
                    var nonContentHeight = modal.height() - $dialogDiv.height();
                    var padding = 50;
                    var maxHeight = $(window).height() - nonContentHeight - padding;

                    $dialogDiv.css({ 'max-height': maxHeight });

                    if (disableScrolling) {
                        $("body").css({ overflow: 'hidden' });
                    }

                    $(window).resize(function () {
                        if (!isOpen) {
                            return;
                        }
                        var maxHeight = $(window).height() - nonContentHeight - padding;
                        $dialogDiv.css({ 'max-height': maxHeight });
                    });

                    if (sizeToWindow) {
                        return; // If this dialog simply sizes to its window, there's no need to resize it dynanmically.
                    }

                    function getElementBottom(element) {
                        var scrollTop = $(window).scrollTop();
                        var elementTop = element.offset().top;
                        var relativeTop = elementTop - scrollTop;
                        var elementHeight = element.height();
                        var bottom = relativeTop + elementHeight + padding;
                        return bottom;
                    }

                    $dialogDiv.mutate("height", function (element, info) {

                        var bottom = getElementBottom(modal);
                        if (bottom > $(window).height()) {
                            $(window).trigger("resize");
                        }
                    });
                }
            });

    	    // open basic dialog, with loading mask
    	    $dialogDiv.dialog("open");
    	    $dialogDiv.append("<div class=\"loadmask\"></div>");
    	    // now call the get, to grab the modal data.
    	    $.get(href, function (data) {
    	        if (!data.length) {
    	            $dialogDiv.find("div.loadmask").remove();
    	            $dialogDiv.remove();
    	            return;
    	        }

    	        var $html = $(data);
    	        // append the data, remove the loading element, then trigger the insert.
    	        $dialogDiv.append($html);
    	        $dialogDiv.find("div.loadmask").remove();
    	        Cobalt.triggerHtmlInsert($dialogDiv);

    	        $dialogDiv.parent().center({ sizeToWindow: sizeToWindow, minWidth: minWidth, maxWidth: maxWidth, maxHeight: maxHeight, autoHeight: autoHeight });
    	    });

    	}
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Modal.js